import { Navigate } from 'react-router-dom'

import { useQuery } from '@apollo/client'
import { EngagementRedirectToRouteDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useFeatures } from 'modules/core/hooks/useFeatures'
import { useNavigation } from 'modules/core/hooks/useNavigation'

import { useEngagementContext } from 'modules/engagement/hooks/useEngagementContext'
import { seeInsights } from 'modules/engagement/lib/authorization'
import { hasEnpsModule } from 'modules/engagement/lib/hasEnpsModule'

const RedirectToRoutePage = () => {
  const { data, loading } = useQuery(EngagementRedirectToRouteDocument)
  const { moduleAvailabilities, enpsInstalled, canManageSurveys, canSeeSmartSurveys } =
    useEngagementContext()
  const { employee: currentEmployee } = useCurrentSession()
  const { has_dev_packaging_paywalls } = useFeatures(['dev_packaging_paywalls'])

  const accessEnpsSeeForms = data?.apiCore._policies.accessEnpsSeeForms.can ?? false
  const canSeeMeetings = data?.meetings._policies.seeMeetings.can ?? false

  const canSeeEnps = hasEnpsModule(moduleAvailabilities) && accessEnpsSeeForms
  const canSeeInsights = seeInsights(
    moduleAvailabilities,
    currentEmployee,
    canManageSurveys,
    has_dev_packaging_paywalls
  )
  const { navigation } = useNavigation()

  if (loading) {
    return
  }

  const buildUrl = () => {
    if (canSeeMeetings) {
      return navigation.engagement.one_on_ones.fullPath()
    }

    if (data?.engagement._policies.seePulseDashboard.can) {
      return navigation.engagement.pulse.fullPath()
    }

    if (canSeeSmartSurveys) {
      return navigation.engagement.smart_surveys.fullPath()
    }

    if (canSeeEnps && enpsInstalled) {
      return navigation.engagement.enps.fullPath()
    }

    if (canSeeInsights) {
      return navigation.engagement.insights.fullPath()
    }

    return navigation.dashboard.fullPath()
  }

  return <Navigate to={buildUrl()} />
}

export default RedirectToRoutePage
